import axios from 'axios';

export default axios.create( {
    "with-credentials":  true, //cookie 
})
